let lazyActions: any;
let _config: any = {};

export const initLazyActions = (config: any = {}) => (_config = config);

const invokeAction =
  (name: string) =>
  (...args: any[]) =>
  async (dispatch: any) => {
    if (!lazyActions && !_config.isSSR) {
      lazyActions = (await import(/* webpackChunkName: "lazy-actions" */ './lazy-actions-chunk'))
        .default;
    }

    return lazyActions[name] ? dispatch(lazyActions[name](...args)) : fallback(name);
  };

function fallback(name: string) {
  if (process.env.NODE_ENV === 'development') {
    throw Error(`"${name}" action does not exist`);
  }
}

export const incrementPostLikeCount = invokeAction('incrementPostLikeCount');
export const requestFileDownloadUrlPromisified = invokeAction('requestFileDownloadUrlPromisified');
export const search = invokeAction('search');
export const clearSearchResults = invokeAction('clearSearchResults');
